import { ArrowDownRight } from 'lucide-react';
import { PROOF_PLATES } from '../atmosphere';
import { services } from '../content';

export function Services() {
  return (
    <section className="services" id="services">
      <div className="services__shell section-shell">
        <header className="services__intro reveal">
          <span className="section-kicker">What I build</span>
          <h2>The operating layer your business is missing.</h2>
          <p>Start with one bottleneck or connect the whole operation. Each piece is designed to work with the others, not become another isolated tool.</p>
        </header>

        <div className="services__body">
          <figure className="services__proof reveal">
            <img src={PROOF_PLATES.verifiedOutput.src} alt={PROOF_PLATES.verifiedOutput.alt} loading="lazy" decoding="async" />
            <figcaption><span>From repeated work</span><ArrowDownRight aria-hidden="true" /><strong>to a dependable system</strong></figcaption>
          </figure>

          <ol className="service-index reveal">
            {services.map((service) => (
              <li key={service.number}>
                <span>{service.number}</span>
                <div><h3>{service.title}</h3><p>{service.description}</p><small>{service.proof}</small></div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
